import { TextProps } from './types'
import { DefaultText } from './variants/DefaultText'
import { LinkText } from './variants/LinkText'

/**
 * Renders text based on variant and typography
 */
export function Text({ variant = 'default', href, ...rest }: TextProps) {
  switch (variant) {
    case 'link': {
      if (href) {
        return <LinkText href={href} {...rest} />
      }
      return <DefaultText {...rest} />
    }
    case 'default': {
      return <DefaultText {...rest} />
    }
  }
}
